import { Box, useTheme } from "@mui/material";

// Onda decorativa do painel split. Cores vêm do tema (sem hex): banda azul mais clara
// (primary.light) + duas linhas secondary (uma grossa, uma fina). Decorativa (aria-hidden).
export const BrandWave = (): JSX.Element => {
  const theme = useTheme();
  return (
    <Box
      component="svg"
      aria-hidden="true"
      viewBox="0 0 600 600"
      preserveAspectRatio="none"
      sx={{
        position: "absolute",
        right: "-10%",
        bottom: "-8%",
        width: "120%",
        height: "70%",
        pointerEvents: "none",
      }}
    >
      <path
        d="M0 420 C 160 330, 300 520, 600 360 L 600 600 L 0 600 Z"
        fill={theme.palette.primary.light}
        opacity={0.6}
      />
      <path
        d="M0 470 C 180 380, 320 560, 600 420"
        fill="none"
        stroke={theme.palette.secondary.main}
        strokeWidth={10}
      />
      <path
        d="M0 505 C 190 420, 330 590, 600 460"
        fill="none"
        stroke={theme.palette.secondary.main}
        strokeWidth={3}
        opacity={0.6}
      />
    </Box>
  );
};
